import type { ProjectContactLink } from "../types";

// Confiance d'une adresse probable bâtie sur le format de la société (worker : PROBABLE_KNOWN_CONFIDENCE).
const COMPANY_FORMAT_CONFIDENCE = 0.5;

export type ProbableEmail = {
  value: string;
  // Format lu sur des adresses de la société, ou format le plus courant (prénom.nom).
  basis: "company" | "common";
  // Nos fournisseurs ont rendu la même adresse, sans pouvoir la vérifier non plus.
  known_by_providers: boolean;
};

/** Adresse probable d'une personne sans adresse livrée (décision du 29/10/2026) : déduite quand le serveur de
 * messagerie accepte tout ou ne répond pas. Gratuite, montrée comme non vérifiable, jamais comptée comme e-mail. */
export const probableEmail = (
  contact: Pick<ProjectContactLink, "email_jsonb" | "evidence">,
): ProbableEmail | null => {
  if (contact.email_jsonb?.length) return null;
  const guess = contact.evidence
    .filter(
      (e) =>
        e.field === "email" &&
        e.method === "inferred" &&
        (e.verification === "catch_all" || e.verification === "unknown"),
    )
    .sort((a, b) => b.collected_at.localeCompare(a.collected_at))[0];
  if (!guess) return null;
  return {
    value: guess.value,
    basis:
      (guess.confidence ?? 0) >= COMPANY_FORMAT_CONFIDENCE
        ? "company"
        : "common",
    known_by_providers: contact.evidence.some(
      (e) =>
        e.field === "email" &&
        e.method === "provider" &&
        e.value.toLowerCase() === guess.value.toLowerCase(),
    ),
  };
};
